/* eslint-disable global-require */
import React, { PureComponent } from 'react';
import { Button } from 'antd';
import IntlMessages from 'src/util/IntlMessages';
import { logOut } from 'src/util/Common';

class Forbidden extends PureComponent {
  render() {
    return (
      <div className="gx-login-container">
        <div className="gx-login-content">
          <div className="gx-login-header">
            <img alt="QTI" src={require('assets/images/logoQTIdata.png')} title="QTI" />
          </div>
          <div className="gx-mb-4">
            <h2>Đăng nhập không hợp lệ!</h2>
            <p><IntlMessages id="app.userAuth.forbidden" /></p>
            <p><IntlMessages id="app.userAuth.contact" /></p>
          </div>
          {/* eslint-disable-next-line no-return-assign */}
          <Button onClick={() => window.location = 'http://egov.quangnam.gov.vn'} type="primary">
            <IntlMessages id="app.userAuth.goBackAppCenter" />
          </Button>
          <Button onClick={() => logOut()}>
            <IntlMessages id="app.userAuth.logOut" />
          </Button>
        </div>
      </div>
    );
  }
}

export default Forbidden;
